//@flow
import * as React from 'react';
import {connect} from "react-redux";
import type {
  formFieldType,
  isSearchable,
  labelTooltip,
  propName,
  propValue,
  selectOptions
} from "../../../../../../../services/flowTypes/componentFlowTypes";
import {
  onGetActTemplateProp,
  onGetValidationStateFormProp
} from "../../../../../../../services/flowTypes/propFnFlowTypes";
import type {disabled, id, label, placeholder} from "../../../../../../../services/flowTypes/appFlowTypes";
import ConnectedFormGroup from "../../../../../../../components/composed/ConnectedFormGroup/ConnectedFormGroup";
import actTemplateValidationScheme from "../../../../../../../configData/actTemplateValidationScheme";
import type {addClasses} from "../../../../../../../services/flowTypes/uiKitFlowTypes";
import actTemplatesEditActions
  from "../../../../../../../store/organization/item/actTemplatesEdit/actTemplatesEditActions";
import PropValueView from "../../../../../../../components/composed/PropValueView/PropValueView";
import {useEffect, useState} from "react";

type Props = {
  formFieldType: formFieldType,
  propName: propName,
  propValue: propValue,
  onGetActTemplateProp: onGetActTemplateProp,
  onGetValidationStateFormProp: onGetValidationStateFormProp,
  label: label,
  labelTooltip?: labelTooltip,
  options?: selectOptions,
  addClasses?: addClasses,
  idForTest?: id,
  disabled?: disabled,
  placeholder?: placeholder,
  readonly?: boolean,
  isSearchable?: isSearchable,
  selectInputId?: id,
  required?: boolean
};

const ActTemplatesFormGroup = (props: Props) => {
  const [validationScheme, setValidationScheme] = useState([])

  useEffect(() => {
    let propValidationPatternsArr = actTemplateValidationScheme[props.propName]
      ? actTemplateValidationScheme[props.propName]
      : null;

    if (props.required === true && (propValidationPatternsArr === null || !propValidationPatternsArr.includes('required'))) {
      propValidationPatternsArr = ['required', ...(propValidationPatternsArr || [])]
    }

    setValidationScheme(propValidationPatternsArr)
  }, [props.propName, props.required]);

  return (
    <>
      {props.readonly ?
        (props.propName === 'isVerified' ? null :
          <PropValueView label={props.label} value={props.propValue}
                         testIdForValue={props.idForTest}/>)
        :
        <ConnectedFormGroup
          formFieldType={props.formFieldType}
          propName={props.propName}
          propValue={props.propValue}
          onGetPropValue={props.onGetActTemplateProp}
          label={props.label}
          labelTooltip={props.labelTooltip}
          options={props.options}
          propValidationPatternsArr={validationScheme}
          addClasses={props.addClasses}
          idForTest={props.idForTest}
          disabled={props.disabled}
          placeholder={props.placeholder}
          isSearchable={props.isSearchable}
          selectInputId={props.selectInputId}
        />
      }
    </>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    propValue: state.organization.item.actTemplatesEdit[ownProps.propName]
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetActTemplateProp: (prop, data) => dispatch({
      type: actTemplatesEditActions.ACT_TEMPLATES_PROP_SET, value: {
        prop: prop,
        data: data
      }
    })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActTemplatesFormGroup);
